import { useEffect, useState } from 'react';
import { useAgentStore } from '../../../store/useAgentStore.js';

/** @returns {[boolean, import('react').Dispatch<import('react').SetStateAction<boolean>>]} */
export function useWorkbenchSurface() {
  const surface = useAgentStore((s) => s.code.ui.workbenchSurface);
  const [ideMode, setIdeMode] = useState(() => surface === 'code');
  useEffect(() => { if (surface) setIdeMode(surface === 'code'); }, [surface]);
  useEffect(() => {
    const show = (event) => setIdeMode(event.detail === 'code');
    window.addEventListener('apolo:workbenchSurface', show);
    return () => window.removeEventListener('apolo:workbenchSurface', show);
  }, []);
  return [ideMode, setIdeMode];
}

export function useLegacyPanelIntro(setOutputsCollapsed, setRightView) {
  useEffect(() => {
    try {
      if (localStorage.getItem('apolo:workbench:v2') !== '0') return;
      if (localStorage.getItem('apolo:hgmq:panelIntro') !== '1') {
        localStorage.setItem('apolo:hgmq:panelIntro', '1');
        setOutputsCollapsed(false);
        setRightView('tasks');
      }
    } catch { /* storage can be unavailable */ }
  }, [setOutputsCollapsed, setRightView]);
}
